import createReducer from '../createReducer'
import {
  LOGIN_LOADING,
  LOGIN_SUCCESS,
  LOGIN_ERROR,
  RELOAD_AUTH_SUCCESS,
  CONNECT_FACEBOOK_LOADING,
  CONNECT_FACEBOOK_SUCCESS,
  CONNECT_FACEBOOK_ERROR,
  LOGIN_WITH_FACEBOOK_LOADING,
  LOGIN_WITH_FACEBOOK_SUCCESS,
  LOGIN_WITH_FACEBOOK_ERROR,
  GET_FACEBOOK_STATUS_SUCCESS,
  FETCH_GEO_IP_SUCCESS,
  INIT_ONBOARDING,
  INIT_FACEBOOK_ONBOARDING,
  INIT_SIGNUP_WITH_FACEBOOK_SUCCESS,
  SIGNUP_ERROR,
  FB_ONBOARDING,
  UACF_ONBOARDING,
  UACF_FB_ONBOARDING,
  GET_FB_PROFILE_SUCCESS,
  STASH_EMAIL_FOR_ONBOARDING,
  STAGE_USER,
  REFRESH_AND_RELOAD_LOADING,
  REFRESH_AND_RELOAD_SUCCESS,
  REFRESH_AND_RELOAD_ERROR,
  CANCEL_ONBOARDING_PROMPT,
  FIND_USER_BY_EMAIL_SUCCESS,
  LOGIN_WITH_WECHAT_LOADING,
  LOGIN_WITH_WECHAT_SUCCESS,
  LOGIN_WITH_WECHAT_ERROR,
  SET_WECHAT_AUTH_STATE,
  SIGNUP_WITH_WECHAT_ERROR,
} from './constants'

export const initialState = {
  authToken: null,
  fbStatus: null,
  fbUserId: null,
  fbAccessToken: null,
  fbExpiresIn: null,
  error: null,
  loggingIn: false,
  onboarding: null,
  uacfId: null,
  uacfProfile: {},
  fbProfile: {},
  onboardingEmail: null,
  geoip: {},
  country: null,
  refreshingToken: false,
  promptOnboarding: false,
  userExists: false,
  isWechatAuth: false,
}

export default createReducer(initialState, {

  name: 'auth',

  [LOGIN_LOADING]: (state) => {
    return { ...state, error: null, loggingIn: true }
  },

  [RELOAD_AUTH_SUCCESS]: (state, action) => {
    const { authToken } = action.payload
    return { ...state, authToken }
  },

  [LOGIN_SUCCESS]: (state) => {
    return { ...state, loggingIn: false }
  },

  [LOGIN_ERROR]: (state, action) => {
    let error

    if (action.payload && action.payload.response && action.payload.response.data) {
      error = action.payload.response.data.error
    } else {
      error = 'unknown_error'
    }

    return { ...state, error, loggingIn: false }
  },

  [LOGIN_WITH_FACEBOOK_LOADING]: (state) => {
    return { ...state, error: null, loggingIn: true }
  },

  [LOGIN_WITH_FACEBOOK_SUCCESS]: (state) => {
    return { ...state, loggingIn: false, error: null }
  },

  [LOGIN_WITH_FACEBOOK_ERROR]: (state, action) => {
    let error

    if (action.payload && action.payload.response && action.payload.response.data) {
      error = action.payload.response.data.error
    } else {
      error = 'unknown_error'
    }

    return { ...state, error: `facebook_${error}`, loggingIn: false }
  },

  [GET_FACEBOOK_STATUS_SUCCESS]: (state, action) => {
    const payload = action.payload
    const status = payload.status
    const connected = status === 'connected' && payload.authResponse
    let newState = { fbStatus: status }

    if (connected) {
      newState = {
        ...newState,
        fbExpiresIn: payload.authResponse.expiresIn,
        fbUserId: payload.authResponse.userID,
        fbAccessToken: payload.authResponse.accessToken,
      }
    }

    return { ...state, ...newState }
  },

  [CONNECT_FACEBOOK_LOADING]: (state) => {
    return { ...state, error: null }
  },

  [CONNECT_FACEBOOK_SUCCESS]: (state, action) => {
    const payload = action.payload

    return {
      ...state,
      error: null,
      fbStatus: payload.status,
      fbExpiresIn: payload.authResponse.expiresIn,
      fbUserId: payload.authResponse.userID,
      fbAccessToken: payload.authResponse.accessToken,
    }
  },

  [CONNECT_FACEBOOK_ERROR]: (state, action) => {
    const payload = action.payload
    return {
      ...state,
      error: 'facebook_connect',
      fbStatus: payload.status,
    }
  },

  [FETCH_GEO_IP_SUCCESS]: (state, action) => {
    const location = action.payload.data.item
    return {
      ...state,
      geoip: action.payload.data.item,
      country: location.country_code,
    }
  },

  [INIT_ONBOARDING]: (state, action) => {
    const {
      uacfProfile,
      username,
      password,
      uacfId,
    } = action.payload

    return {
      ...state,
      uacfId,
      onboarding: UACF_ONBOARDING,
      uacfProfile: {
        ...uacfProfile,
        email: username,
        password: password,
      },
    }
  },

  [INIT_FACEBOOK_ONBOARDING]: (state, action) => {
    const { uacfProfile, uacfId } = action.payload

    return {
      ...state,
      uacfId,
      onboarding: UACF_FB_ONBOARDING,
      uacfProfile,
    }
  },

  [INIT_SIGNUP_WITH_FACEBOOK_SUCCESS]: (state) => {
    return { ...state, onboarding: FB_ONBOARDING }
  },

  [GET_FB_PROFILE_SUCCESS]: (state, action) => {
    return { ...state, fbProfile: action.payload }
  },

  [SIGNUP_ERROR]: (state, action) => {
    let error = 'unknown', promptOnboarding = false

    if (action.payload
      && action.payload.response
      && action.payload.response.data
      && action.payload.response.data.error
    ) {
      error = action.payload.response.data.error
    }
    // handle existing email error, prompt user to go to login?
    if (error === 'email/used') {
      promptOnboarding = true
    }

    return { ...state, error: error, promptOnboarding: promptOnboarding }
  },

  [CANCEL_ONBOARDING_PROMPT]: (state) => {
    return { ...state, promptOnboarding: false }
  },

  [STASH_EMAIL_FOR_ONBOARDING]: (state, action) => {
    return { ...state, onboardingEmail: action.payload }
  },

  [STAGE_USER]: (state, action) => {
    return { ...state, stagedUser: action.payload }
  },

  [REFRESH_AND_RELOAD_LOADING]: (state, action) => {
    const quiet = action.meta.quiet
    return { ...state, refreshingToken: !quiet }
  },

  [REFRESH_AND_RELOAD_ERROR]: (state) => {
    return { ...state, refreshingToken: false }
  },

  [REFRESH_AND_RELOAD_SUCCESS]: (state) => {
    return { ...state, refreshingToken: false }
  },

  [FIND_USER_BY_EMAIL_SUCCESS]: (state, action) => {
    const data = action.payload.data
    return { ...state, promptOnboarding: data.userExists }
  },

  [LOGIN_WITH_WECHAT_LOADING]: (state) => {
    return { ...state, error: null, loggingIn: true }
  },

  [LOGIN_WITH_WECHAT_SUCCESS]: (state) => {
    return { ...state, error: null, loggingIn: false }
  },

  [LOGIN_WITH_WECHAT_ERROR]: (state, action) => {
    let error

    if (action.payload && action.payload.response && action.payload.response.data) {
      error = action.payload.response.data.error
    } else {
      error = 'unknown_error'
    }

    return { ...state, error: `wechat_${error}`, loggingIn: false }
  },

  [SET_WECHAT_AUTH_STATE]: (state) => {
    return {
      ...state,
      isWechatAuth: true,
    }
  },

  [SIGNUP_WITH_WECHAT_ERROR]: (state, action) => {
    let error = 'unknown', promptOnboarding = false

    if (action.payload
      && action.payload.response
      && action.payload.response.data
      && action.payload.response.data.error
    ) {
      error = action.payload.response.data.error
    }

    // handle existing email error, prompt user to go to login?
    if (error === 'email/used') {
      promptOnboarding = true
    }

    return { ...state, error: error, promptOnboarding: promptOnboarding }
  },
})
